import React, { Component } from 'react'
import L from 'leaflet'

const _default = {
  lat: 60.1299967,
  lng: 14.7206008,
  zoom: 6
}
class FlowMap extends Component {
  componentDidMount () {
    this.map = L.map('map', {
      center: [this.props.lat || _default.lat, this.props.lng || _default.lng],
      zoom: this.props.zoom || _default.zoom,
      maxZoom: 17,
      layers: [
        L.tileLayer('http://maps.maintrac.se/tile/{z}/{x}/{y}.png', {
          attribution: 'Hosted by Maintrac AB &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors.'
        })
      ]
    })
    if (!this.props.marker) return
    this.marker = L.marker([this.props.lat || _default.lat, this.props.lng || _default.lng], {
      draggable: this.props.draggable,
      autoPan: true
    }).addTo(this.map)
    if (!this.props.draggable) return
    this.marker.on('dragend', e => {
      var position = e.target.getLatLng()
      if (this.props.onDragEnd) this.props.onDragEnd(position)
    })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.lat !== nextProps.lat || this.props.lng !== nextProps.lng) {
      this.marker.setLatLng(L.latLng(nextProps.lat, nextProps.lng))
      this.map.panTo(L.latLng(nextProps.lat, nextProps.lng))
    }
  }

  render () {
    return (
      <div id='map' style={{ height: this.props.height || 'auto' }} />
    )
  }
}
export default FlowMap



// WEBPACK FOOTER //
// ./src/components/basic/displays/FlowMap.js